import http from "./httpService";
import config from "./../config.json";

let apiEndpoint = process.env.REACT_APP_API_URL || config.apiUrl;
apiEndpoint += "dashboard";

export const getAccountCompletionAsync = async () => {
  const { data } = await http.get(`${apiEndpoint}/accounts/completion`);
  return data;
};

export const getAccountStatusesCountAsync = async () => {
  const { data } = await http.get(`${apiEndpoint}/accounts/statuses`);
  return data;
};

export const getAccountSignupsAsync = async (
  frequency,
  start_date,
  end_date
) => {
  const url = `${apiEndpoint}/accounts/signups/${frequency}?from=${start_date}&to=${end_date}`;
  const { data } = await http.get(url);
  return data;
};

export const getMonthlyActiveAccountsAsync = async (start_date, end_date) => {
  const url = `${apiEndpoint}/accounts/active/monthly?from=${start_date}&to=${end_date}`;
  const { data } = await http.get(url);
  return data.result;
};

export const getMonthlyCumulativeActiveAccountsAsync = async (
  start_date,
  end_date
) => {
  const url = `${apiEndpoint}/accounts/active/cumulative/monthly?from=${start_date}&to=${end_date}`;
  const { data } = await http.get(url);
  return data.result;
};

export const getMonthlyInvoicesAmountAsync = async (start_date, end_date) => {
  const url = `${apiEndpoint}/financials/invoices/monthly?from=${start_date}&to=${end_date}`;
  const { data } = await http.get(url);
  return data.result;
};

export const getMonthlyArrearsAmountAsync = async (start_date, end_date) => {
  const url = `${apiEndpoint}/financials/arrears/monthly?from=${start_date}&to=${end_date}`;
  const { data } = await http.get(url);
  return data.result;
};

export const getMonthlyPaymentsAmountAsync = async (start_date, end_date) => {
  const url = `${apiEndpoint}/financials/payments/monthly?from=${start_date}&to=${end_date}`;
  const { data } = await http.get(url);
  return data.result;
};

export const getMonthlyProjectedInvoicesAmountAsync = async (
  start_date,
  end_date
) => {
  const url = `${apiEndpoint}/financials/projected-invoices/monthly?from=${start_date}&to=${end_date}`;
  const { data } = await http.get(url);
  return data.result;
};

export const getTopCitiesSignupCount = async () => {
  const { data } = await http.get(`${apiEndpoint}/accounts/cities`);
  return data;
};

export const getTotalAccountAsync = async () => {
  const { data } = await http.get(`${apiEndpoint}/accounts/total`);
  return data;
};

export const getTotalInvoiceAmountAsync = async () => {
  const { data } = await http.get(`${apiEndpoint}/invoices/total`);
  return data;
};

export const getTotalPaymentAmountAsync = async () => {
  const { data } = await http.get(`${apiEndpoint}/payments/total`);
  return data;
};

export const getTotalUnverifiedCreditablesAsync = async () => {
  const { data } = await http.get(
    `${apiEndpoint}/creditable-withholding-taxes/unverified/total`
  );
  return data;
};

export const getTotalUnverifiedReceiptsAsync = async () => {
  const { data } = await http.get(
    `${apiEndpoint}/official-receipts/unverified/total`
  );
  return data;
};

export const getIncomeTaxSubmissionAsync = async (params) => {
  const { year, quarter } = params;

  const url = `${apiEndpoint}/taxes/income-tax/completion?year=${year}&quarter=${quarter}`;
  const { data } = await http.get(url);
  return data;
};

export const getPercentageTaxQuarterlySubmissionAsync = async (params) => {
  const { year, quarter } = params;

  const url = `${apiEndpoint}/taxes/percentage-tax-quarterly/completion?year=${year}&quarter=${quarter}`;
  const { data } = await http.get(url);
  return data;
};

export const getRegistrationFeeSubmissionAsync = async (year) => {
  const url = `${apiEndpoint}/taxes/registration-fee/completion?year=${year}`;
  const { data } = await http.get(url);
  return data;
};

const dashboardService = {
  getAccountCompletionAsync,
  getAccountStatusesCountAsync,
  getAccountSignupsAsync,
  getMonthlyActiveAccountsAsync,
  getMonthlyCumulativeActiveAccountsAsync,
  getMonthlyInvoicesAmountAsync,
  getMonthlyArrearsAmountAsync,
  getMonthlyPaymentsAmountAsync,
  getMonthlyProjectedInvoicesAmountAsync,
  getTopCitiesSignupCount,
  getTotalAccountAsync,
  getTotalInvoiceAmountAsync,
  getTotalPaymentAmountAsync,
  getTotalUnverifiedCreditablesAsync,
  getTotalUnverifiedReceiptsAsync,
  getIncomeTaxSubmissionAsync,
  getPercentageTaxQuarterlySubmissionAsync,
  getRegistrationFeeSubmissionAsync,
};

export default dashboardService;
